
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.93 18.007"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.43 10.152a5.19 5.19 0 012.82.85 6.62 6.62 0 012.13 2.24c.236.909.42 1.83.55 2.76C15.9 18.692 2 18.682 0 15.932c.12-.922.29-1.836.51-2.74a5.86 5.86 0 012.07-2.13 5.341 5.341 0 012.603-.824l.277-.006 2.89 1.82a1.14 1.14 0 001.11.073l.13-.073 2.84-1.9zM12.459 3.662c0-2.021-1.56-3.66-3.484-3.66S5.49 1.641 5.49 3.662c0 .512.004 2.16.648 3.345.73 1.345 1.495 2.207 2.837 2.207 1.286 0 1.959-.62 2.68-1.924.673-1.215.804-3.101.804-3.628z"}})])
          )
        }
      }
    